module.exports = __webpack_public_path__ + "/images/logo-af-corte-ingles.b6af720.svg";